export default __webpack_public_path__ + "static/media/branch-kyzyl-kyia.b3bfcc17.png";